import { render, staticRenderFns } from "./CreateEmbedForm.vue?vue&type=template&id=24398c8e&scoped=true&"
import script from "./CreateEmbedForm.vue?vue&type=script&lang=js&"
export * from "./CreateEmbedForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateEmbedForm.vue?vue&type=style&index=0&id=24398c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24398c8e",
  null
  
)

export default component.exports